// extracted by mini-css-extract-plugin
export default {"wrapper":"Q9-z"};